module.exports = __webpack_public_path__ + "static/media/justmovein.68460163.svg";